/* eslint-disable @typescript-eslint/no-empty-function */

import { createClient, deleteClient, updateClient } from "./clients-service";
import { ClientType, ClientModel, ClientInformation, ClaimType } from "./types";

export interface Client {
  id: number;
  name: string;
  type: ClientType;
  claimType: ClaimType;
  enabled: boolean;
}

export async function createOne(data: Partial<ClientInformation>) {
  await createClient({
    clientInformation: data,
  } as ClientModel);
}

export async function updateOne(data: Partial<ClientInformation>) {
  await updateClient({
    clientInformation: data,
  } as ClientModel);
}

export async function deleteOne(clientId: number) {
  await deleteClient(clientId);
}

type ValidationResult = {
  issues: { message: string; path: (keyof Client)[] }[];
};

export function validate(client: Partial<Client>): ValidationResult {
  let issues: ValidationResult["issues"] = [];

  if (!client.name) {
    issues = [...issues, { message: "Name is required", path: ["name"] }];
  }

  if (!client.type) {
    issues = [...issues, { message: "Claim type is required", path: ["type"] }];
  }

  if (!client.claimType) {
    issues = [
      ...issues,
      { message: "Default claim type is required", path: ["claimType"] },
    ];
  }

  return { issues };
}
